// ============================================================================
// CabinetTestingTab.tsx — вкладка «Тестирование» кабинета.
//
// Не второй движок тестов: используется существующая страница «Тесты и анкеты»
// (PollService.ListPollTypes + GetPollFull + ListTableData + SubmitPollAnswers).
// Тот же экран, что в «Предприятии» и конфигураторе: список методик, вопросы,
// «Пройти» и протоколы прохождения. Новых proto и серверных прав нет —
// доступность данных и запись определяет сервер.
// ============================================================================

import { FilledPollsPage } from '@/pages/FilledPollsPage';

export function CabinetTestingTab() {
  return <FilledPollsPage />;
}
